/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SetUserTelegramInternalRequest { 
    id: string;
    telegramChatId?: string | null;
    telegramLogin?: string | null;
}

